import { render, staticRenderFns } from "./SaicSituationByPeriod.vue?vue&type=template&id=ce21d2ea&scoped=true"
import script from "./SaicSituationByPeriod.vue?vue&type=script&lang=js"
export * from "./SaicSituationByPeriod.vue?vue&type=script&lang=js"
import style0 from "./SaicSituationByPeriod.vue?vue&type=style&index=0&id=ce21d2ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce21d2ea",
  null
  
)

export default component.exports